import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
//取消默认样式
import './static/css/resetDefault.css'
import './static/css/commonStyle.css'

import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts';
import 'echarts-gl'

//引入一级页面路由地址列表
import {firstMenuPathList} from '@/modules/firstMenuPathList'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.echarts = echarts
//bus总线
Vue.prototype.$bus = new Vue()
//路由守卫
router.beforeEach((to,from,next)=>{
  console.log(`to ${to.path}`)
  console.log(`from ${from.path}`)

  //验证登录，否则跳转到登录界面
  if(to.path !== '/Login' && !store.state.isLogin) {
    Vue.prototype.$message.warning('请登陆验证!')
    // Vue.prototype.$notify({
    //   title: '警告',
    //   message: '请登陆验证!',
    //   type: 'warning'
    // })
    router.push('/Login')
    // next()
  } else {
    //验证跳转地址是否是以及菜单页面
    if(firstMenuPathList.indexOf(to.path) > -1 && store.state.menuLevel !== 1) store.commit('setMenuLevel', 1)
    next()
  }
  
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
